import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import Moment from 'react-moment';
import DataTable from '../DataTable';
import Slider from "react-slick";
import ScrollContainer from 'react-indiana-drag-scroll'
import useApi from '../../api/useApi';
import ChatService from '../../services/ChatService';
import UsersService from '../../services/UsersService';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import useAuth from '../../context/useAuth';
import useQueryParams from '../../context/useQueryParams';
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { NumericFormat } from 'react-number-format';
import TimeCountdown from './TimeCountdown';
//import boopSfx from '../../sounds/boop.mp3';


const AuctioneerLotDetails = () => {
    const [lotSummary, setLotSummary] = useState({});
    const [lotList, setLotList] = useState([]);
    const [lotDetail, setLotDetail] = useState({});
    const [selectedLot, setSelectedLot] = useState(null);
    const [currentRunningLot, setCurrentRunningLot] = useState(null);
    const [auctionStatus, setAuctionStatus] = useState(null);
    const [previousStatus, setPreviousStatus] = useState(null);
    const [modalVisible, setModalVisible] = useState(false);
    const { id } = useParams();
    const { parameters, setParameters } = useQueryParams();
    const api = useApi();
    const lotListRef = React.useRef(lotList);
    const scrollContainerRef = useRef(null);
    const [auctionTime, setAuctionTime] = useState(null);
    const [lotStartPrice, setLotStartPrice] = useState(null);
    const [startPriceInputEnabled, setStartPriceInputEnabled] = useState(false);
    const startPriceInputRef = useRef(null);
    const [participantList, setParticipantList] = useState([]);
    const [bidderPriceList, setBidderPriceList] = useState([]);
    const [activityMessages, setActivityMessages] = useState([]);
    const [bidResult, setBidResult] = useState(null);
    const [forbiddenMessage, setForbiddenMessage] = useState(null);
    const [emptySpaceOccupiers, setEmptySpaceOccupiers] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36]);
    //const [lotAuction, setLotAuction] = useState(null);
    const [goToLotNo, setGoToLotNo] = useState(null);
    //const [initialJumpToLotNo, setInitialJumpToLotNo] = useState(null);//don't remove this line
    //const initialJumpToLotNoRef = React.useRef(initialJumpToLotNo);
    const [goToLotClass, setGoToLotClass] = useState('');
    const [messages, setMessages] = useState([]);
    const [waitingMessage, setWaitingMessage] = useState('');
    const [currentMessage, setCurrentMessage] = useState('');
    const msgRef = useRef(null);
    const panelRef = useRef(null);
    const { auth } = useAuth();
    const [role] = useState(auth?.role?.toLowerCase());
    const navigate = useNavigate();
    //const [play] = useSound(boopSfx);
    const thousandSeparator = num => num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const handleConnectedUsers = (users) => {
        setParticipantList(users);
    };


    ///ON PAGE LOAD JUMP TO LOT/BAG NUMBER
    //useEffect(() => {
    // initialJumpToLotNoRef.current = parameters.initialJumpToLotNo;
    // setInitialJumpToLotNo(parameters.initialJumpToLotNo)
    //  }, [])

    const validateEndTime = (endTime) => {
        const currentDate = new Date();
        const endDateTime = new Date(endTime);

        endDateTime.setFullYear(currentDate.getFullYear());
        endDateTime.setMonth(currentDate.getMonth());
        endDateTime.setDate(currentDate.getDate());

        const difference = endDateTime - currentDate;

        if (difference <= 0) {
            alert('STOP. Auction time up! All traders will be logged out automatically. Please close the auction.');

            const _msg = {
                auctionId: parseInt(id),
                message: "AUCTION_TIME_UP_LOGOUT"
            }
            _chatService.sendMessage(_msg);
            return false;
        }
        else
            return true;
    }

    const handleOnConnectionEstablished = useRef(() => {
        //if (role === 'primary auctioneer')
        //   loadLotSummary();
        //else {
        api.getLotSummary(id).then((lotData) => {
            lotListRef.current = lotData.lotDetail;
            const _currentBids = lotData.currentBids;
            setLotList(lotData.lotDetail);
            lotData.currentBids = null;
            lotData.lotDetail = null;
            setLotSummary(lotData);
            triggerLotPosition(lotData, _currentBids, parameters?.initialJumpToLotNo);
        });

        // }

        _chatService.getOnlineUsers(handleConnectedUsers)

    }).current;

    const handleOnMessageReceived = useRef((message) => {
        //console.log("Message Received " + new Date())
        //console.log(message)

        if (message) {
            switch (message.message) {
                case 'FORBIDDEN':
                    {
                        setForbiddenMessage(message.error);
                        break;
                    }
                case 'GET_LOT_SUMMARY':
                    {
                        const lotData = message.payload;
                        lotListRef.current = lotData.lotDetail;
                        const _currentBids = lotData.currentBids;
                        setLotList(lotData.lotDetail);
                        lotData.currentBids = null;
                        lotData.lotDetail = null;
                        setLotSummary(lotData);
                        triggerLotPosition(lotData, _currentBids, -1);
                        validateEndTime(lotData.auctionEndTime);
                        break;
                    }
                case 'GET_LOT_DETAIL':
                    {
                        setLotDetail(message.payload);
                        if (message.payload.auctionStartPriceRs && message.payload.status === 0 && message.payload.auctionStartPriceRs > 0) {
                            if (lotStartPrice === null || lotStartPrice === '') {
                                setLotStartPrice(message.payload.auctionStartPriceRs);
                            }
                        }

                        break;
                    }
                case 'PROCESS_LOT':
                    setParameters(prev => ({ ...prev, initialJumpToLotNo: -1 }));
                    setActivityMessages(prevMessages => [...prevMessages, { message: 'Lot Processed', name: message.sender, contactNo: message.contactNo }])
                    setAuctionStatus("PROCESS_LOT");
                    setWaitingMessage('Waiting for secondary input...');
                    if (role === 'secondary auctioneer' || role === 'support auctioneer') {
                        const currentLot = lotListRef.current.find(t => t.lotId === message.lotId);
                        if (currentLot) {
                            setSelectedLot(currentLot);
                            setCurrentRunningLot(currentLot);
                            setTimeout(() => {
                                scrollToLot(parseInt(currentLot.lotId));
                            }, 100);
                        }
                    }
                    else if (role === 'primary auctioneer') {
                        setStartPriceInputEnabled(true);
                        startPriceInputRef.current.focus();
                    }


                    break;
                case 'DISTRIBUTE_LOT':
                    setParameters(prev => ({ ...prev, initialJumpToLotNo: -1 }));
                    setActivityMessages(prevMessages => [...prevMessages, { message: 'Lot Distributed', name: message.sender, contactNo: message.contactNo }])
                    setAuctionStatus("DISTRIBUTE_LOT");
                    setWaitingMessage('Waiting for primary input...');

                    if (role === 'primary auctioneer') {
                        setStartPriceInputEnabled(true);
                        startPriceInputRef.current.focus();
                    }
                    break;
                case 'START_LOT':
                    setParameters(prev => ({ ...prev, initialJumpToLotNo: -1 }));
                    setActivityMessages(prevMessages => {
                        const updatedMessages = [...prevMessages.slice(-1), { message: 'Lot Started', name: message.sender, contactNo: message.contactNo }];
                        return updatedMessages;
                    });
                    setLotStartPrice(message.payload.currentLotDetail.auctionStartPriceRs);
                    setAuctionStatus("START_LOT");
                    setPreviousStatus("START_LOT");
                    if (role === 'secondary auctioneer' || role === 'support auctioneer') {
                        const currentLot = lotListRef.current.find(t => t.lotId === message.lotId);
                        if (currentLot) {
                            setSelectedLot(currentLot);
                            setCurrentRunningLot(currentLot);
                            setTimeout(() => {
                                scrollToLot(parseInt(currentLot.lotId));
                            }, 100);
                        }
                    }
                    setGoToLotNo('');
                    setWaitingMessage('');
                    break;
                case 'PLACE_BID':
                    if (message.payload) {
                        setBidderPriceList(previousBids => [{ bidderName: message.payload.bidderName, contactNo: message.contactNo, bidAmount: message.bidAmount, bidNo: message.bidNo, bidTime: message.bidTime, tableNo: message.payload.tableNo, location: message.payload.location }, ...(Array.isArray(previousBids) ? previousBids : [])]);
                    }
                    setAuctionStatus("PLACE_BID");
                    break;
                case 'LOT_ACCEPTED_REQUEST':

                    // setActivityMessages(prevMessages => [...prevMessages, { message: 'Lot Accepted', name: message.sender, contactNo: message.contactNo }])
                    setActivityMessages(prevMessages => {
                        const updatedMessages = [...prevMessages.slice(-1), { message: 'Lot Accepted', name: message.sender, contactNo: message.contactNo }];
                        return updatedMessages;
                    });

                    if (role === 'primary auctioneer')
                        setWaitingMessage('Waiting for secondary input...');
                    else if (role === 'secondary auctioneer')
                        setWaitingMessage('Waiting for primary input...');

                    break;
                case 'LOT_WITHDRAWN_REQUEST':
                    {   // setActivityMessages(prevMessages => [...prevMessages, { message: 'Lot Withdrawn', name: message.sender, contactNo: message.contactNo }])
                        setActivityMessages(prevMessages => {
                            const updatedMessages = [...prevMessages.slice(-1), { message: 'Lot Withdrawn', name: message.sender, contactNo: message.contactNo }];
                            return updatedMessages;
                        });

                        if (role === 'primary auctioneer')
                            setWaitingMessage('Waiting for secondary input...');
                        else if (role === 'secondary auctioneer')
                            setWaitingMessage('Waiting for primary input...');

                        break;
                    }
                case 'LOT_RERUN_REQUEST':
                    //setActivityMessages(prevMessages => [...prevMessages, { message: 'Lot ReRun', name: message.sender, contactNo: message.contactNo }])
                    setActivityMessages(prevMessages => {
                        const updatedMessages = [...prevMessages.slice(-1), { message: 'Lot ReRun', name: message.sender, contactNo: message.contactNo }];
                        return updatedMessages;
                    });

                    if (role === 'primary auctioneer') {
                        setStartPriceInputEnabled(true);
                        setWaitingMessage('Waiting for secondary input...');
                    }
                    else if (role === 'secondary auctioneer')
                        setWaitingMessage('Waiting for primary input...');

                    setLotStartPrice('');

                    break;
                case 'LOT_SOLD':
                    {
                        setParameters(prev => ({ ...prev, initialJumpToLotNo: -1 }));
                        setAuctionStatus('LOT_SOLD');
                        setActivityMessages([]);
                        setBidResult(prevState => ({
                            ...prevState,
                            lotId: message.payload.lotId,
                            lotNo: message.payload.lotNumber,
                            buyer: message.payload.bidderName,
                            tableNo: message.payload.tableNo,
                            location: message.payload.location,
                            bidAmount: message.bidAmount,
                            type: 'sold'
                        }));
                        //setCurrentRunningLot(null);
                        setLotStartPrice('');
                        setSelectedLot('');

                        if (role === 'primary auctioneer') //THIS WILL RELOAD DATA FOR ALL USERS
                        {
                            setTimeout(() => {
                                loadLotSummary();
                                pushNextLotToTraders();
                            }, 100)
                        }
                        setWaitingMessage('');
                        break;
                    }
                case 'LOT_WITHDRAWN':
                    {
                        setParameters(prev => ({ ...prev, initialJumpToLotNo: -1 }));
                        setAuctionStatus('LOT_WITHDRAWN');
                        setActivityMessages([]);
                        setBidResult(prevState => ({
                            ...prevState,
                            lotId: message.payload.lotId,
                            lotNo: message.payload.lotNumber,
                            buyer: message.payload.bidderName,
                            tableNo: message.payload.tableNo,
                            location: message.payload.location,
                            bidAmount: message.bidAmount,
                            type: 'withdrawn'
                        }));
                        //setCurrentRunningLot(null);
                        setLotStartPrice('');
                        if (role === 'primary auctioneer')//THIS WILL RELOAD DATA FOR ALL USERS
                        {
                            setTimeout(() => {
                                loadLotSummary();
                                pushNextLotToTraders();
                            }, 200)
                        }
                        setWaitingMessage('');
                        break;
                    }
                case 'LOT_RERUN':
                    {
                        setParameters(prev => ({ ...prev, initialJumpToLotNo: -1 }));
                        setAuctionStatus('LOT_RERUN');
                        setActivityMessages([]);
                        setActivityMessages(prevMessages => {
                            const updatedMessages = [...prevMessages.slice(-1), { message: 'Lot ReRun', name: message.sender, contactNo: message.contactNo }];
                            return updatedMessages;
                        });
                        setBidResult(prevState => ({
                            ...prevState,
                            lotId: message.payload.lotId,
                            lotNo: message.payload.lotNumber,
                            buyer: message.payload.bidderName,
                            bidAmount: message.bidAmount,
                            type: 'rerun'
                        }));
                        //setCurrentRunningLot(null);
                        setLotStartPrice('');
                        // setAuctionStatus(null);
                        if (role === 'primary auctioneer')//THIS WILL RELOAD DATA FOR ALL USERS
                        {
                            setTimeout(() => {
                                loadLotSummary();
                                pushNextLotToTraders();
                                startPriceInputRef.current.focus();
                            }, 300)
                        }
                        setWaitingMessage('');
                        break;
                    }
                case 'AUCTION_CLOSED':
                    {
                        setModalVisible(true);
                        setTimeout(() => {
                            setModalVisible(false);
                            setTimeout(() => {
                                navigate('/auctioneer')
                            }, 1000)
                        }, 3000)
                        break;
                    }
                default:
            }
        }

    }).current;

    const handleOnTimerTick = useRef((seconds) => {
        // console.log(3)
        setAuctionTime(seconds);

        //(currentRunningLot === null || currentRunningLot === undefined ||
        //    (currentRunningLot != null && selectedLot != null && currentRunningLot.lotId === selectedLot.lotId)) ? /*&& */

        //setActivityMessages([]);
        // console.log("Timer "+ seconds)
    }).current;

    const triggerLotPosition = (lotData, _currentBids, initialJumpToLotNo) => {
        let currentLot = lotListRef.current.find(t => t.status >= 1 && t.status <= 5);
        const isLotInProcessLot = lotListRef.current.find(t => t.status >= 1 && t.status <= 5);
        const lastRunLotIndex = lotListRef.current.findIndex(t => t.lotId === parseInt(lotData.lastRunLotId));

        if (lastRunLotIndex >= 0) {
            for (var i = lastRunLotIndex; i < lotListRef.current.length; i++) {
                if (lotListRef.current[i].status >= 1 && lotListRef.current[i].status <= 5 && lotListRef.current[i].isSuspectedLot === false && lotListRef.current[i].isColoredLot === false) {
                    currentLot = lotListRef.current[i];
                    break;
                }
            }
        }

        if (initialJumpToLotNo > 0) {
            currentLot = lotListRef.current.find(t => t.lotNumber === parseInt(initialJumpToLotNo));
        }

        if (currentLot) {

            if (currentLot.status === 1 || isLotInProcessLot?.status === 1) {
                setAuctionStatus('PROCESS_LOT');
                if (role === 'primary auctioneer')
                    setStartPriceInputEnabled(true);
            }
            else if (currentLot.status === 2 || isLotInProcessLot?.status === 2) {
                setAuctionStatus('DISTRIBUTE_LOT');
                if (role === 'primary auctioneer')
                    setStartPriceInputEnabled(true);
            }
            else if (currentLot.status === 3 || isLotInProcessLot?.status === 3) {
                setAuctionStatus('START_LOT');
            }
            else if (currentLot.status === 4 || isLotInProcessLot?.status === 4) {
                setAuctionStatus('TIME_UP');
            }
            else if (currentLot.status === 5 || isLotInProcessLot?.status === 5) {
                if (role === 'primary auctioneer')
                    setStartPriceInputEnabled(true);
            }

            setTimeout(() => {
                scrollToLot(parseInt(currentLot.lotId));
                setSelectedLot(currentLot);
                if (isLotInProcessLot)
                    setCurrentRunningLot(isLotInProcessLot);

                setBidderPriceList(_currentBids);

                //if (currentLot.lotId === lotListRef.current[0].lotId)
                loadLotDetail(currentLot.lotId)

                if (auctionTime === null && currentLot.status === 3) {
                    setAuctionStatus('TIME_UP');
                    setAuctionTime(0);
                }

            }, 100);

        }
        else {
            const auctionStartedCount = lotListRef.current.filter(item => item.status !== 0).length;

            if (auctionStartedCount === 0 && (currentLot === null || currentLot === undefined)) {
                currentLot = lotListRef.current[0];
                loadLotDetail(currentLot.lotId)
                scrollToLot(parseInt(currentLot.lotId));
                setSelectedLot(currentLot);

                if (currentLot.status === 3) {
                    setAuctionStatus('TIME_UP');
                    setCurrentRunningLot(null);
                    setAuctionTime(0);
                } else if (currentLot.status === 5) {
                    if (role === 'primary auctioneer')
                        setStartPriceInputEnabled(true);
                }
            }
            else {

                const lastRunLotIndex = lotListRef.current.findIndex(t => t.lotId === parseInt(lotData.lastRunLotId));


                let nextLotToSelect = lotListRef.current.find(item => item.status === 0);

                for (var j = lastRunLotIndex; j < lotListRef.current.length; j++) {
                    if (lotListRef.current[j].status === 0 && lotListRef.current[j].isSuspectedLot === false && lotListRef.current[j].isColoredLot === false) {
                        nextLotToSelect = lotListRef.current[j];
                        break;
                    }
                }

                if (nextLotToSelect) {
                    setTimeout(() => {
                        scrollToLot(parseInt(nextLotToSelect.lotId));
                        //loadLotDetail(nextLotToSelect.lotId)

                        setSelectedLot(nextLotToSelect);
                    }, 100)

                }
            }

        }

    }

    const handleOnTimerTimeout = useRef((lotId) => {


        if (auctionStatus !== "START_LOT")
            setAuctionStatus('TIME_UP');

        setTimeout(() => {
            if (auctionStatus !== "START_LOT") {
                setAuctionStatus('TIME_UP');
            }
        }, 100)


        const currentLot = lotListRef.current.find(t => t.lotId === lotId);
        if (currentLot) {
            setSelectedLot(currentLot);
            setCurrentRunningLot(currentLot);
        }

    }).current;


    const handleOnUserJoined = useRef((user) => {
        setParticipantList((prevUsers) => [...prevUsers, user]);
    }).current;

    const handleOnUserLeft = useRef((user) => {
        setParticipantList((prevUsers) => prevUsers.filter((participant) => participant.userCode !== user.userCode));
    }).current;


    const _chatService = ChatService({ onConnectionEstablished: handleOnConnectionEstablished, socketLoggedOnCallback: handleOnUserJoined, socketLoggedOutCallback: handleOnUserLeft, timerTick: handleOnTimerTick, timerTimeout: handleOnTimerTimeout, messageReceived: handleOnMessageReceived, });
    // const _userService = UsersService({ socketLoggedOnCallback: handleOnUserJoined, socketLoggedOutCallback: handleOnUserLeft });

    const linkRenderer = (props) => {

        const location = (props.node.data.location === 1 ? "P" : (props.node.data.location === 2 ? "B" : props.node.data.location));
        const tableNo = props.node.data.tableNo;

        const cellValue = props.valueFormatted ? props.valueFormatted : props.value + ' [' + location + ' - ' + tableNo + ']';

        return <span> {cellValue}</span>
    };

    const linkRendererDate = (props) => {

        const cellValue = props.valueFormatted ? props.valueFormatted : props.value;

        return <Moment format="hh:mm:ss A">{cellValue}</Moment>;
    };

    const columns = [
        { headerName: '#', field: 'bidNo', headerClass: 'text-center', cellClass: 'text-center', width: 40 },
        { headerName: 'Bid (₹)', field: 'bidAmount', headerClass: 'text-center', cellRenderer: (props) => { return <span>{thousandSeparator(props.value)}</span> }, cellClass: 'text-center', width: 60 },
        { headerName: 'Bidder Name', field: 'bidderName', cellRenderer: linkRenderer, flex: 1, },
        { headerName: 'Time', field: 'bidTime', headerClass: 'text-center', cellClass: 'text-center', cellRenderer: linkRendererDate, width: 100 },
    ];

    const gridOptions = {
        defaultColDef: {
            wrapHeaderText: true,
            autoHeaderHeight: true,
        },
        columnDefs: columns,
        rowClass: 'custom-grid-font',
        getRowClass: params => {
            if (params.node.rowIndex % 2 === 0) {
                return 'bg-gray-50-i';
            }
        }
    };

    const bagRenderer = (props) => {

        let bag;
        const indicator = [1, 2, 3, 4, 5].find(t => t === props.status) ? <span className="current-bag"></span> : null;
        if (props.isSpecialLot && props.status === 7) { //special lot skip
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-special-skip">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.isSpecialLot && props.status === 6) { //special lot withdrawn
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-special-withdrawn">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        } else if (props.isSpecialLot && props.status === 8) { //special lot sold
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-special-sold">
                <span>{props.lotNumber}</span>
                <small className="sold-price"> <small className="tx-6"> ₹</small>{props.finalPrice}</small>
            </span>
        }
        else if (props.isSpecialLot) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-special">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.isColoredLot) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-colored">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.isSuspectedLot) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-suspected">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.status === 6) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-withdrawn">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        } else if (props.status === 7) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-skip">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        else if (props.status === 8) {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-sold">
                <span>{props.lotNumber}</span>
                <small className="sold-price"> <small className="tx-6"> ₹</small>{props.finalPrice}</small>
            </span>
        }
        else {
            bag = <span id={`lot-${props.lotId}`} className="lot-bag bag-green">
                <span>{props.lotNumber}</span>
                {indicator}
            </span>
        }
        return bag;
    }


    const bidResultRenderer = (props) => {

        let result;
        if (props === null)
            return null;

        if (props.type === "sold") {
            const location = (props.location === 1 ? "P" : (props.location === 2 ? "B" : props.location));
            const tableNo = props.tableNo;

            result = <div role="alert" class="mg-b-0 fade d-flex align-items-center alert fade show alert-dismissible alert-success alert show pd-8">
                <span class="alert-inner--icon">
                    <i class="fe fe-info me-2"></i>
                </span>
                <span class="alert-inner--text tx-14">
                    <strong>Lot No {props.lotNo} </strong>: Sold to {props.buyer} [{location} - {tableNo}] at ₹ {props.bidAmount}
                </span>
            </div>
        }
        else if (props.type === "withdrawn") {
            result = <div role="alert" class="mg-b-0 fade alert d-flex align-items-center fade show alert-dismissible alert-danger alert show pd-8">
                <span class="alert-inner--icon">
                    <i class="fe fe-info me-2"></i>
                </span>
                <span class="alert-inner--text tx-14">
                    <strong>Lot No {props.lotNo} </strong>: Withdrawn.
                </span>
            </div>
        }
        else if (props.type === "rerun") {
            result = <div role="alert" class="mg-b-0 fade alert d-flex align-items-center fade show alert-dismissible alert-primary alert show pd-8">
                <span class="alert-inner--icon">
                    <i class="fe fe-info me-2"></i>
                </span>
                <span class="alert-inner--text tx-14">
                    <strong>Lot No {props.lotNo} </strong>: being re-run.
                </span>
            </div>
        }
        return result;
    }

    const loadLotSummary = async () => {

        const _msg = {
            auctionId: parseInt(id),
            message: "GET_LOT_SUMMARY"
        }
        _chatService.sendMessage(_msg);
    };

    const loadLotDetail = async (lotId) => {
        const _msg = {
            lotId: parseInt(lotId),
            message: "GET_LOT_DETAIL"
        }
        _chatService.sendMessage(_msg);

    };

    const pushNextLotToTraders = async () => {
        try {
            const _msg = {
                message: "LIVE_AUCTION"
            }
            _chatService.sendMessage(_msg);

        } catch (error) {
            alert('Unable to push next lot to traders.');
        }
    };


    useEffect(() => {
        //AUTO SCROLL TO NEXT LOT, WHEN PREVIOUS LOT IS COMPLETED
        if (auctionStatus === null && bidResult) {

            if (bidResult.type !== "rerun") { ///IF LOT IS NOT RE-RUN THEN PROCEED TO NEXT LOT

                //const lastRunLotIndex = lotListRef.current.findIndex(t => t.lotId === parseInt(lotSummary.lastRunLotId));
                const lastRunLotIndex = lotListRef.current.findIndex(t => t.lotId === parseInt(bidResult.lotId));
                //const currentIndex = lotListRef.current.findIndex(t => t.lotId === parseInt(bidResult.lotId));

                var nextLot = null;
                for (var i = (lastRunLotIndex + 1); i < lotListRef.current.length; i++) {
                    if (lotListRef.current[i].status !== 7 && lotListRef.current[i].isSuspectedLot === false && lotListRef.current[i].isColoredLot === false) {
                        nextLot = lotListRef.current[i];
                        break;
                    }
                }

                if (nextLot) {

                    ///JUST TO AVOID SAME MESSAGE AT EXACT SAME TIME, QUEUE THE MESSAGE BY ADD SOME DELAY AS PER ROLE
                    if (role === 'primary auctioneer')
                        scrollToLot(parseInt(nextLot.lotId));
                    else if (role === 'secondary auctioneer')
                        setTimeout(() => {
                            scrollToLot(parseInt(nextLot.lotId));
                        }, 100)
                    else if (role === 'support auctioneer')
                        setTimeout(() => {
                            scrollToLot(parseInt(nextLot.lotId));
                        }, 200)

                    setSelectedLot(nextLot);
                }
            }
        }

    }, [auctionStatus, bidResult]);



    useEffect(() => {
        console.log("AUCTION STATUS =========> " + auctionStatus + " " + new Date())
        if (auctionStatus === "LOT_SOLD" || auctionStatus === "LOT_WITHDRAWN" || auctionStatus === "LOT_RERUN") {
            setAuctionStatus(null);
            setCurrentRunningLot(null);
            setSelectedLot(null);
            setBidderPriceList([]);
        }

    }, [auctionStatus]);


    useEffect(() => {

        //const handleConnectedUsers = (users) => {
        //    setParticipantList(users);
        //};

        //_chatService.getOnlineUsers(handleConnectedUsers)
        return () => {
            // _chatService.cleanup();
        };
    }, [_chatService]);

    const handleScroll = () => {

        const activeBagContainer = document.getElementById('active-bag-container')

        //console.log("scrollContainerCARD LEFT " + scrollContainer.getBoundingClientRect().left);
        //console.log("bagContainer LEFT " + activeBagContainer.getBoundingClientRect().left);

        const activeContainerStart = activeBagContainer.getBoundingClientRect().left;
        const activeContainerWidth = activeBagContainer.getBoundingClientRect().width;
        const activeContainerEnd = activeContainerStart + activeContainerWidth;

        //console.log("activeContainerLeft " + activeContainerStart)
        //console.log("activeContainerWidth " + activeContainerWidth)
        //console.log("activeContainerRight " + activeContainerEnd)

        const firstVisibleLot = lotList.find((lot, index) => {
            const lotElement = document.getElementById(`lot-${lot.lotId}`);
            if (lotElement) {
                const { left, right } = lotElement.getBoundingClientRect();

                return left >= activeContainerStart && right <= activeContainerEnd;
            }
            return false;
        });
        setSelectedLot(firstVisibleLot)
        //// Do something with the firstVisibleLot
        //console.log('First visible lot:', firstVisibleLot);
    };

    const handleOnScrollEnd = () => {
        const container = scrollContainerRef.current.container.current;
        const scrollPosition = scrollContainerRef.current.container.current.scrollLeft;
        const nearestMultiple = Math.round(scrollPosition / 60) * 60;

        if (scrollPosition % 60 !== 0) {
            container.scrollTo({
                left: nearestMultiple, // Adjust based on your use case (e.g., left or top)
                behavior: 'smooth', // You can use 'auto' or 'smooth' for the scrolling behavior
            });
        }

        if (selectedLot)
            loadLotDetail(selectedLot.lotId)

        setParameters(prev => ({ ...prev, initialJumpToLotNo: -1 }));
        // setInitialJumpToLotNo(selectedLot.lotNumber)
        //setTimeout(() => {
        //    console.log("auto scrolling ended "+new Date())
        //    if (selectedLot)
        //      loadLotDetail(selectedLot.lotId)
        //}, (Math.floor(Math.random() * (5 - 1 + 1)) + 1))
    }

    const scrollToLot = async (lotId) => {


        const container = scrollContainerRef.current.container.current;
        const lotIndex = lotListRef.current.findIndex(t => t.lotId === lotId);
        const lotElement = document.getElementById(`lot-${lotId}`);
        if (lotElement) {
            container.scrollTo({
                left: (lotIndex * 60), // Adjust based on your use case (e.g., left or top)
                behavior: 'smooth', // You can use 'auto' or 'smooth' for the scrolling behavior
            });
        }

    }

    const handleLotStartPriceChange = (value) => {
        setLotStartPrice(value);
    }

    const onProcessLot = async () => {
        if (validateEndTime(lotSummary?.auctionEndTime)) {
            if (selectedLot) {

                const _msg = {
                    lotId: parseInt(selectedLot.lotId),
                    message: "PROCESS_LOT"
                }

                _chatService.sendMessage(_msg);

                setCurrentRunningLot(selectedLot);
                setAuctionStatus("PROCESS_LOT");
            }
            else
                alert("Please select a lot");
        }
    }

    const onStartLot = async () => {
        if (lotStartPrice > 100) {
            setStartPriceInputEnabled(false);
            if (selectedLot) {

                const _msg = {
                    lotId: parseInt(selectedLot.lotId),
                    lotStartPrice: parseFloat(lotStartPrice),
                    message: "START_LOT"
                }

                _chatService.sendMessage(_msg);
                setCurrentRunningLot(selectedLot);
                setAuctionStatus("START_LOT");
                setPreviousStatus("START_LOT");
            }
            else
                alert("Please select a lot");
        } else
            alert("Please enter start price.");
    }

    const onLotDistributed = async () => {

        if (selectedLot) {
            //  console.log("sending DISTRIBUTE_LOT")
            const _msg = {
                lotId: parseInt(selectedLot.lotId),
                message: "DISTRIBUTE_LOT"
            }

            _chatService.sendMessage(_msg);
            // console.log("sent DISTRIBUTE_LOT")
            setCurrentRunningLot(selectedLot);
            setAuctionStatus("DISTRIBUTE_LOT");
        }
        else
            alert("Please select a lot");
    }

    const onLotAcceptRequest = async () => {

        if (selectedLot) {
            const _msg = {
                lotId: parseInt(selectedLot.lotId),
                message: "LOT_ACCEPTED_REQUEST"
            }

            _chatService.sendMessage(_msg);
            setAuctionStatus("LOT_ACCEPTED_REQUEST");
            setPreviousStatus("LOT_ACCEPTED_REQUEST");
        }
        else
            alert("Please select a lot");
    }

    const onLotWithdrawnRequest = async () => {

        if (selectedLot) {

            const _msg = {
                lotId: parseInt(selectedLot.lotId),
                message: "LOT_WITHDRAWN_REQUEST"
            }
            _chatService.sendMessage(_msg);
            setAuctionStatus("LOT_WITHDRAWN_REQUEST");
        }
        else
            alert("Please select a lot");
    }

    const onReRunLotRequest = async () => {

        if (selectedLot) {
            setBidderPriceList(null);
            const _msg = {
                lotId: parseInt(selectedLot.lotId),
                message: "LOT_RERUN_REQUEST"
            }
            _chatService.sendMessage(_msg);
            setAuctionStatus("LOT_RERUN_REQUEST");

        }
        else
            alert("Please select a lot");
    }

    const handleGoToLotChange = (event) => {
        setGoToLotNo(event.target.value);
    }

    const handleGoToLotKeyDown = (event) => {
        if (event.key === 'Enter') {
            setGoToLotClass('')
            const goToLot = lotListRef.current.find(t => t.lotNumber === parseInt(goToLotNo));
            if (goToLot) {
                setGoToLotNo('');
                scrollToLot(goToLot.lotId)
            }
            else {
                setGoToLotClass('go-to-lot-error')
            }
        }
    }

    return (
        <div>
            <div className="inner-body">
                <button className="btn btn-outline-primary btn-sm mg-t-10 tx-10" style={{ borderColor: "#c1c1c1" }} onClick={() => navigate(`/auctioneerLots/${lotDetail.auctionId}`)}><i class="ti ti-arrow-left me-2"></i>Back</button>

                {role !== 'support auctioneer' ?
                    lotSummary.isThreshHoldReached === 1 ?
                        <h6 className="m-0 mt-2 pd-4 text-center bg-warning rounded-pill" ><i className="ti ti-alert"></i> Total Sale value is about to reach the Bank Guarantee amount, once it reaches the BG amount, no further sale of lots will be allowed.</h6>
                        : lotSummary.isThreshHoldReached === 2 ? <h6 className="m-0 mt-2 pd-4 text-center bg-red rounded-pill" ><i className="ti ti-na"></i> Stop! Hereafter, further lots are not allowed to be processed as the total sale value has reached the Bank Guarantee amount. Please contact administrator.</h6>
                            : null
                    : null}

                <div className="row row-sm mg-md-t-10 mg-b-5 mg-sm-t-70 mg-xs-t-70">

                    <div className="col-md-12">

                        <div className="card overflow-visible" id="scroll-container-card" >
                            <div className="pd-5  d-flex justify-content-around fs-13" style={{ backgroundColor: "#6259ca0d", borderBottomWidth: '1px', borderBottomStyle: "solid", borderBottomColor: '#dfdfdf' }}>
                                <div className="d-flex justify-content-around flex-fill rounded-top-11 rounded-start-0 align-items-center">
                                    <span className="mg-b-0">Total Lots  : <strong>{lotSummary.totalLots}</strong></span>
                                </div>
                                <div className="d-flex justify-content-around flex-fill bd-r  align-items-center">
                                    <span className="mg-b-0">Lots Remaining  : <strong>{lotSummary.lotsRemaining}</strong></span>
                                </div>
                                <div className=" d-flex justify-content-around flex-fill rounded-top-11 rounded-end-0 bd-r align-items-center">
                                    <span className="mg-b-0">Lots Sold : <strong>{lotSummary.lotsSold}</strong> </span>
                                </div>
                                <div className="d-flex justify-content-around flex-fill bd-r  align-items-center">
                                    <span className="mg-b-0">Lots Withdrawn : <strong>{lotSummary.lotsWithdrawn}</strong></span>
                                </div>
                                <div className="d-flex justify-content-around flex-fill bd-r  align-items-center">
                                    <span className="mg-b-0">Total Auction Qty. : <strong>{lotSummary.totalQuantity}</strong> kg</span>
                                </div>

                            </div>

                            <div id="active-bag-container" className="active-bag"></div>

                            <ScrollContainer
                                className="scroll-container d-flex flex-row justify-content-start pd-8 pd-l-140 overflow-x-scroll scrollbar-hide"
                                onScroll={handleScroll}
                                ref={scrollContainerRef}
                                vertical={false}
                                horizontal={role === 'primary auctioneer' ? true : false}
                                onEndScroll={handleOnScrollEnd}
                            >
                                {lotList.map((t, index) => {

                                    //return <div key={index} className="lot-bag-container" >
                                    return <div key={index} className="lot-bag-container" onClick={() => { if (role === 'primary auctioneer') { scrollToLot(t.lotId) } }}>
                                        {bagRenderer(t)}
                                    </div>
                                })}

                                {emptySpaceOccupiers.map((t, index) => {
                                    return <div key={index} className="lot-bag-container">

                                    </div>
                                })}
                            </ScrollContainer>
                            {/*OPTION  TO ADD GO TO*/}
                            {role === 'primary auctioneer' ?
                                <div id="go-to-lot-container" class="go-to-lot-container"><span>Go to</span>
                                    <input type="number" className={`${goToLotClass ? goToLotClass + ' ' : ''}form-control wd-50 pd-4 text-center go-to-lot`} value={goToLotNo} onChange={handleGoToLotChange} onKeyDown={handleGoToLotKeyDown} onBlur={() => setGoToLotNo('')} min="1" max={lotList.length - 1} placeholder="enter lot no & press enter" style={{ maxWidth: "100%" }} />
                                </div> : null}
                        </div>
                    </div >
                </div >
                <div className="row row-sm ">
                    <div className="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xxl-12">
                        <div className="row row-sm">
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <div className="card custom-card mg-b-6" style={{ minHeight: '337px', borderTopWidth: '7px', borderTopColor: "#3b3b6e", borderTopStyle: "solid" }}>

                                    <div className="card-body pd-t-0 row fs-12">

                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 bg-gray-100">

                                            {selectedLot ? <div>
                                                <div className="card-header border-bottom-0 pd-l-0 pd-t-10">
                                                    <label className="main-content-label my-auto pt-2 pd-b-10">Lot Details</label>
                                                </div>
                                                <table className="table mb-0 border-top table-bordered   small-cell-padding" style={{ fontSize: '0.8rem', maxWidth: "100%", whiteSpace: "pre-wrap !important" }} >

                                                    <tbody>
                                                        <tr >
                                                            <td className="highlight-light " style={{ width: "50%" }}>Seller</td>
                                                            <th className="text-end highlight-light-force">{lotDetail?.planterDealer === '1' ? 'Planter' : (lotDetail?.planterDealer === '2' ? 'Dealer' : lotDetail?.planterDealer) || "--"} </th></tr>
                                                        <tr >
                                                            <td >Planter Name</td>
                                                            <th className="text-end ">{lotDetail?.planterName || "--"} </th></tr>
                                                        <tr>
                                                            <td >Quantity (kg)</td>
                                                            <th className="text-end">{lotDetail?.quantityKg || "--"} Kg</th></tr>
                                                        <tr><td >Liter-Weight</td>
                                                            <th className="text-end">{lotDetail?.litreWeightGms || "--"} Grams</th>
                                                        </tr>
                                                        <tr><td >No. of Bags</td>
                                                            <th className="text-end">{lotDetail?.bags || "--"}</th>
                                                        </tr>
                                                        <tr><td >Reserve Price (₹)</td>
                                                            <th className="text-end">{lotDetail?.reservedPrice || "--"}</th>
                                                        </tr>
                                                        <tr><td >Start Price (₹)</td>
                                                            <th className="text-center p-0">
                                                                <NumericFormat prefix={'₹ '} getInputRef={(inputInstance) => {
                                                                    startPriceInputRef.current = inputInstance;
                                                                }} disabled={!startPriceInputEnabled} onValueChange={(values) => handleLotStartPriceChange(values.value)} value={lotStartPrice} allowLeadingZeros={false} thousandSeparator="," decimalScale={0} className="form-control rounded-0 pd-r-5 text-end highlight-light" />
                                                                {/*<input type="text" maxLength="" disabled={!startPriceInputEnabled} value={lotStartPrice || ''} onChange={handleLotStartPriceChange} className="form-control rounded-0 pd-r-5 text-end highlight-light"></input>*/}
                                                            </th>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div> : (selectedLot ? nextLotPlaceholder : awaitLotPlaceholder)}
                                        </div>
                                        <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 d-flex flex-column justify-content-between">

                                            {!selectedLot && <div className="mg-t-20" > <Skeleton height={24} count={3} /></div>}

                                            {selectedLot ?
                                                <div >
                                                    <div className="card-header border-bottom-0 pd-l-0 pd-t-10">
                                                        <label className="main-content-label my-auto pt-2 pd-b-10">Activity Center</label>
                                                    </div>
                                                    <div className="d-flex justify-content-between">
                                                        <span>  Lot Number : <strong className="tx-18 text-primary"> {selectedLot?.lotNumber}</strong></span>
                                                        <span>  <strong className="tx-18 text-primary">{lotDetail?.quantityKg || "--"} kg</strong></span>
                                                    </div>
                                                    <table className="table mb-0 border-top table-bordered text-nowrap small-cell-padding" style={{ maxWidth: "100%", whiteSpace: "pre-wrap !important" }}>
                                                        <tbody>

                                                            {activityMessages?.length > 0 && currentRunningLot?.lotId === selectedLot?.lotId ?
                                                                activityMessages?.map(m => {
                                                                    return <tr>
                                                                        <th scope="row" >{m.contactNo}<br></br>{m.name} </th>
                                                                        <td>{m.message}</td>
                                                                    </tr>
                                                                }) : selectedLot ? <tr>
                                                                    <td colSpan="2">No update available.</td>
                                                                </tr> : null}
                                                            <cite className='mg-3'> <small> {waitingMessage}</small></cite>
                                                        </tbody>
                                                    </table>

                                                </div> : null}
                                            <div className="d-flex  bd-t pd-t-4">
                                                <span className="mg-t-4 mg-4">Time remaining : </span>
                                                <h4 className="text-primary">00:0{auctionTime}</h4>
                                            </div>

                                        </div>

                                        {lotSummary?.isThreshHoldReached !== 2 &&
                                            (currentRunningLot === null || currentRunningLot === undefined ||
                                                (currentRunningLot != null && selectedLot != null && currentRunningLot.lotId === selectedLot.lotId)) ? /*&& */
                                            <div className="form-group mg-t-20 pd-l-0 mg-b-0">
                                                <div className="btn-list ">
                                                    {role === 'primary auctioneer' && (auctionStatus === null && (selectedLot?.status === 0 || selectedLot?.status === 6) && selectedLot?.isSuspectedLot === false && selectedLot?.isColoredLot === false) ?
                                                        <button className="btn btn-sm ripple btn-primary fs-11  ps-4 pe-4" onClick={onProcessLot}>Process Lot</button> : null}

                                                    {role === 'primary auctioneer' && (auctionStatus === 'DISTRIBUTE_LOT' || (auctionStatus === null && selectedLot?.status === 5 && selectedLot?.isSuspectedLot === false && selectedLot?.isColoredLot === false)) ?
                                                        <button className="btn btn-sm ripple btn-primary fs-11  ps-4 pe-4" onClick={onStartLot}>Start Lot</button> : null}

                                                    {role === 'secondary auctioneer' && auctionStatus === 'PROCESS_LOT' ?
                                                        <button className="btn btn-sm ripple btn-primary fs-11  ps-4 pe-4" onClick={onLotDistributed}>Lot Distributed</button> : null}

                                                    {role !== 'support auctioneer' && auctionStatus === 'TIME_UP' && bidderPriceList?.length > 0 ?
                                                        <button className="btn btn-sm ripple btn-success fs-11  ps-4 pe-4" onClick={onLotAcceptRequest}>Accept</button> : null}

                                                    {role !== 'support auctioneer' && auctionStatus === 'TIME_UP' && (previousStatus === null || previousStatus === "START_LOT") ?
                                                        <button className="btn btn-sm ripple btn-danger fs-11  ps-4 pe-4" onClick={onLotWithdrawnRequest}>Withdraw</button> : null}

                                                    {role !== 'support auctioneer' && auctionStatus === 'TIME_UP' && (previousStatus === null || previousStatus === "START_LOT") ?
                                                        <button className="btn btn-sm ripple btn-info fs-11  ps-4 pe-4" onClick={onReRunLotRequest}>Re-Run</button> : null}
                                                </div>
                                                <div className="mg-t-20">
                                                    {
                                                        auctionStatus === 'TIME_UP' && bidderPriceList?.length > 0 ? <div role="alert" class="mg-b-0 fade alert fade show alert-dismissible alert-primary alert show pd-8">
                                                            <span class="alert-inner--icon">
                                                                <i class="fe fe-check-square me-2"></i>
                                                            </span>
                                                            <span class="alert-inner--text tx-14">
                                                                <strong>Lot No {currentRunningLot != null ? currentRunningLot.lotNumber : null} </strong>: Bidding closed at ₹  <strong> {bidderPriceList != null && bidderPriceList?.length > 0 ? thousandSeparator(bidderPriceList[0]?.bidAmount) : null}</strong>
                                                            </span>

                                                        </div> :
                                                            auctionStatus === 'TIME_UP' && bidderPriceList?.length === 0 && (previousStatus === null || previousStatus === "START_LOT") ? <div role="alert" class="mg-b-0 fade alert fade show alert-dismissible alert-warning alert show pd-8">
                                                                <span class="alert-inner--icon">
                                                                    <i class="fe fe-info me-2"></i>
                                                                </span>
                                                                <span class="alert-inner--text tx-14">
                                                                    <strong>Lot No {currentRunningLot != null ? currentRunningLot.lotNumber : null} </strong>: No bid placed.
                                                                </span>

                                                            </div> : null
                                                    }

                                                </div>
                                            </div> : <div className="form-group mg-t-10 pd-l-0"></div>
                                        }

                                        {forbiddenMessage ? <div className="form-group mg-t-10 pd-l-0 mg-b-0">
                                            <div className="mg-t-10">
                                                <div class="alert alert-danger mb-0" role="alert">
                                                    <span class="alert-inner--icon"><i class="fe fe-slash me-2"></i></span>
                                                    <span class="alert-inner--text">
                                                        <strong>{forbiddenMessage}</strong>
                                                    </span>
                                                </div>
                                            </div>
                                        </div> : null}

                                        {bidResultRenderer(bidResult)}

                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <div className="card custom-card  mg-b-6">
                                    <div className="card-header border-bottom-0 pd-t-10 d-flex justify-content-between">
                                        <label className="main-content-label my-auto pt-2 pd-b-10">Bid Details</label>
                                        <label className="main-content-label my-auto pt-2 pd-b-10">Participants : {participantList?.length}</label>
                                    </div>
                                    <div className="card-body pd-t-0">
                                        <div
                                            style={{ height: 316 }}
                                            className={
                                                "ag-theme-alpine"
                                            }
                                        >
                                            <AgGridReact rowHeight={34} gridOptions={gridOptions}
                                                rowData={bidderPriceList}
                                            /></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row row-sm">
                    <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12 grid-margin">
                        <div className="card custom-card">
                            <div className="pd-5 pd-l-20 pd-r-20 fs-13" style={{ backgroundColor: "#6259ca0d", borderBottomWidth: '1px', borderBottomStyle: "solid", borderBottomColor: '#dfdfdf' }}>
                                <div className="d-flex justify-content-between">
                                    <span className="mg-b-0">Auctioneer  : <strong>{lotDetail?.companyName}</strong> </span>
                                    <span className="mg-b-0 text-primary"> {lotSummary?.auctionEndTime ? <TimeCountdown endTime={lotSummary?.auctionEndTime} /> : null}</span>
                                </div>
                            </div>

                            <div className="d-flex justify-content-around pd-t-10 pd-b-5">
                                <div className="pe-0 ps-0">
                                    <div className="card-body text-center pd-4">
                                        <h6 className="mb-0">Auction Min</h6>
                                        <h4 className="mb-1  number-font">
                                            <span className="counter">₹</span>{lotSummary?.auctionMin?.toFixed(2)}</h4>

                                    </div>
                                </div>
                                <div className="pe-0 ps-0">
                                    <div className="card-body text-center  pd-4">
                                        <h6 className="mb-0">Auction Max</h6>
                                        <h4 className="mb-1  number-font">
                                            <span className="counter">₹</span>{lotSummary?.auctionMax?.toFixed(2)}</h4>
                                    </div>
                                </div>
                                <div className="pe-0 ps-0">
                                    <div className="card-body text-center  pd-4">
                                        <h6 className="mb-0">Auction Avg</h6>
                                        <h4 className="mb-1 number-font">
                                            <span className="counter">₹</span>{lotSummary?.auctionAvg?.toFixed(2)}</h4>
                                    </div>
                                </div>
                                <div className="pe-0 ps-0">
                                    <div className="card-body text-center  pd-4">
                                        <h6 className="mb-0">Grower Avg</h6>
                                        <h4 className="mb-1  number-font">
                                            <span className="counter">₹</span>{lotSummary?.growerAvg?.toFixed(2)}</h4>
                                    </div>
                                </div>
                                <div className="pe-0 ps-0">
                                    <div className="card-body text-center  pd-4">
                                        <h6 className="mb-0">Dealer Avg</h6>
                                        <h4 className="mb-1  number-font">
                                            <span className="counter">₹</span>{lotSummary?.dealerAvg?.toFixed(2) || '-'}</h4>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div >
            <Modal show={modalVisible} centered>
                <Modal.Header className="modal-header pd-12">
                    <Modal.Title>Auction closed.</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="text-center">
                        <h3 className="tx-danger">"Current auction has been closed."</h3>
                        <p>Redirecting to home page...</p>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default AuctioneerLotDetails;

const awaitLotPlaceholder = (
    <div className="d-flex flex-column pd-20">
        <h6 className="tx-gray-700">Awating lot selection...</h6>
        <p>Scroll horizontally to select a lot</p>
        <Skeleton containerClassName="flex-1" height={24} count={4} style={{ marginBottom: "2px" }} />
    </div>)

const nextLotPlaceholder = (
    <div className="d-flex flex-column pd-20">
        <h5 className="tx-gray-700">Proceeding to next lot.</h5>
        <h5 className="tx-gray-700">Please wait...</h5>
        <Skeleton containerClassName="flex-1" height={24} count={4} style={{ marginBottom: "2px" }} />
    </div>)